import React from 'react';
import { motion } from 'framer-motion';
import { Check, BookOpen, Printer, Smile, Clock } from 'lucide-react';
export function SolutionSection() {
  const benefits = [{
    icon: BookOpen,
    title: 'Te diga qué dar',
    desc: 'Manuales explicativos claros'
  }, {
    icon: Printer,
    title: 'Te dé las actividades',
    desc: 'Listas para imprimir o proyectar'
  }, {
    icon: Check,
    title: 'Te permita corregir rápido',
    desc: 'Claves de corrección incluidas'
  }, {
    icon: Clock,
    title: 'Te devuelva tiempo',
    desc: 'Y cabeza para descansar'
  }];
  return <section className="py-20 bg-white" data-id="element-176">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-177">
        <div className="text-center mb-16" data-id="element-178">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-179">
            LO QUE REALMENTE NECESITÁS
          </motion.h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-180">
            No necesitás más ideas. No necesitás más PDFs. No necesitás más
            cursos.
            <br data-id="element-181" />
            <span className="font-bold text-blue-600 text-2xl block mt-2" data-id="element-182">
              Necesitás un motor de clases armado.
            </span>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20" data-id="element-183">
          {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-blue-50 p-8 rounded-2xl border border-blue-100 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1" data-id="element-184">
              <div className="bg-white w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm text-blue-600" data-id="element-185">
                <benefit.icon className="w-7 h-7" data-id="element-186" />
              </div>
              <h3 className="font-bold text-gray-900 mb-3 text-lg" data-id="element-187">
                {benefit.title}
              </h3>
              <p className="text-gray-600" data-id="element-188">{benefit.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-gray-900 text-white rounded-3xl p-8 md:p-16 shadow-2xl overflow-hidden relative" data-id="element-189">
          <div className="absolute top-0 right-0 w-96 h-96 bg-blue-600 rounded-full filter blur-[100px] opacity-20 -translate-y-1/2 translate-x-1/2" data-id="element-190"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-600 rounded-full filter blur-[80px] opacity-20 translate-y-1/2 -translate-x-1/2" data-id="element-191"></div>

          <div className="relative z-10 grid md:grid-cols-2 gap-16 items-center" data-id="element-192">
            <div data-id="element-193">
              <h3 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-194">
                PACK INGLÉS <span className="text-blue-400" data-id="element-195">LISTO™</span>
              </h3>
              <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-196">
                Es un sistema modular de clases listas por tema gramatical.
                Diseñado para que recuperes tu vida fuera del aula.
              </p>
              <ul className="space-y-5 mb-10" data-id="element-197">
                {['Manual explicativo claro', 'Actividades listas para imprimir', 'Claves de corrección', 'Plantillas editables'].map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-198">
                    <div className="bg-blue-600 rounded-full p-1.5 flex-shrink-0" data-id="element-199">
                      <Check className="w-4 h-4 text-white" data-id="element-200" />
                    </div>
                    <span className="text-lg font-medium" data-id="element-201">{item}</span>
                  </li>)}
              </ul>
              <div className="bg-white/10 p-6 rounded-xl backdrop-blur-md border border-white/10" data-id="element-202">
                <p className="font-mono text-sm text-blue-300 mb-3 uppercase tracking-wider" data-id="element-203">
                  Modo de uso:
                </p>
                <div className="flex flex-wrap items-center gap-2 text-sm md:text-base font-bold text-white" data-id="element-204">
                  <span data-id="element-205">Abrís</span> <span className="text-blue-400" data-id="element-206">→</span>
                  <span data-id="element-207">Imprimís</span> <span className="text-blue-400" data-id="element-208">→</span>
                  <span data-id="element-209">Das la clase</span>{' '}
                  <span className="text-blue-400" data-id="element-210">→</span>
                  <span data-id="element-211">Corregís</span>
                </div>
              </div>
            </div>

            <div className="bg-white/5 p-8 md:p-10 rounded-3xl border border-white/10 backdrop-blur-sm" data-id="element-212">
              <h4 className="text-xl font-bold mb-8 text-center text-blue-200" data-id="element-213">
                CUANDO LO USÁS, PASA ESTO:
              </h4>
              <ul className="space-y-4 flex flex-col items-center" data-id="element-214">
                {['Entrás al aula segura', 'Las clases tienen orden', 'Los alumnos participan más', 'Vos tenés tiempo', 'Tu cabeza descansa'].map((item, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.2 + i * 0.1
              }} className="flex items-center justify-start gap-4 bg-gray-800/80 p-4 rounded-xl w-full max-w-sm border border-gray-700 hover:border-gray-600 transition-colors" data-id="element-215">
                    <Smile className="w-6 h-6 text-yellow-400 flex-shrink-0" data-id="element-216" />
                    <span className="font-medium" data-id="element-217">{item}</span>
                  </motion.li>)}
              </ul>
              <div className="mt-10 text-center" data-id="element-218">
                <p className="text-blue-300 font-medium mb-2" data-id="element-219">
                  Y volvés a sentir algo que parecía perdido:
                </p>
                <p className="text-3xl font-bold text-white tracking-tight" data-id="element-220">
                  TRANQUILIDAD DOCENTE.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}